import {
    AccountRetrievalRequest,
    RestDataResponseAccount_Account,
    accountPost,
} from '@cecm-microservices-sdk/core/services/account';
import { getMicroservicesClient } from '@/services/microservices/client';
import type { MicroservicesCountryCode } from './usedCarEligibility';

export type AccountDetailsResponse = RestDataResponseAccount_Account;

export async function fetchAccountDetails(
    countryCode: MicroservicesCountryCode,
    payload: AccountRetrievalRequest,
): Promise<AccountDetailsResponse> {
    const client = getMicroservicesClient(countryCode);

    if (!client.baseUrl) {
        throw new Error(
            `Missing microservices base URL for ${countryCode.toUpperCase()}. Check the runtime configuration for the active environment.`,
        );
    }

    return accountPost(client, payload);
}
